import React from "react";
import { Accordion } from "react-bootstrap";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import styles from "./style.module.scss";

interface AccordionProps {
  Data: { title: any; content: any }[];
}

const CustomAccordion: React.FC<AccordionProps> = ({ Data }) => {
  return (
    <Accordion
      defaultActiveKey="0"
      className={styles.customAccordion} // wrapper for scoping
    >
      {Data.map((data, index) => (
        <Accordion.Item eventKey={String(index)} key={index}>
          <Accordion.Header className={`${styles.customAccordion} my-2`}>
            <span className={styles.accordionHeaderContent}>
              <IoIosArrowDroprightCircle
                className={styles.accordionIcon}
                size={20}
              />
              <span className={styles.accordionTitle}>{data.title}</span>
            </span>
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            {data.content}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default CustomAccordion;
